import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { RktIconComponent } from '@rocketfinancialcorp/rocket-ui/icon';

import { Counterparty } from '@shared/models';

export type CounterpartyDetailsAction = 'SUSPEND' | 'UNSUSPEND' | 'REMOVE';

@Component({
  selector: 'app-counterparty-details-header',
  templateUrl: './counterparty-details-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RktIconComponent],
})
export class CounterpartyDetailsHeaderComponent {
  @Input() counterparty?: Counterparty;

  @Input() isControlsDisabled = true;

  @Output() btnClicked = new EventEmitter<CounterpartyDetailsAction>();
}
